import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface TripAuditTrailRow {
  addedUpdatedOn: string;
  description: string;
}

@Component({
  selector: 'app-trip-audit-trail-dialog',
  templateUrl: './trip-audit-trail-dialog.component.html',
  styleUrls: ['./trip-audit-trail-dialog.component.scss']
})
export class TripAuditTrailDialogComponent implements OnInit {

  tripCode = '';
  rows: TripAuditTrailRow[] = [];

  constructor(
    public dialogRef: MatDialogRef<TripAuditTrailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { tripCode?: string; rows?: TripAuditTrailRow[] }
  ) { }

  ngOnInit(): void {
    this.tripCode = this.data?.tripCode || '';
    this.rows = this.data?.rows || [];
  }

  onClickCancel(): void {
    this.dialogRef.close();
  }

}
